module.exports = __webpack_public_path__ + "img/9.797177f5.png";